import { useNavigate } from "react-router-dom";
import * as React from "react";
import * as PS from "../styles";
import * as S from "./styles";
import { CardProps } from "../types";

export const Default = ({ onNavigate, cardSelected, cardSelectedBuilding, referencePoint, type, ...card }: CardProps & { onNavigate?: (arg?: any) => void, cardSelected: any, type: string, cardSelectedBuilding: any, onMobileClick?: any }) => {

  const [isValid, setIsValid] = React.useState(false);

  const navigate = useNavigate();

  const id = card.accommodation_id;

  const handleTrue = card.disableClick

  const titleLimiter = (title: string) => {
    if (title?.length > totalLength) {
      return title.slice(0, totalLength) + '...'
    } else {
      return title
    }
  }

  const totalLength = 44 - 10

  const handleNavigate = (e: React.MouseEvent) => {
    if (type === 'default') {
      cardSelected(card.accommodation_id)
      cardSelectedBuilding(card.building_yogha)
    } else if (type === 'unit') {
      cardSelected(card.title)
    }

  };

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();

  };
  return (
    <>
      <PS.GlobalContainer  >
        <PS.Container onClick={card.onMobileClick} draggable='false' onMouseDown={handleNavigate} >
          {card.gadget && <PS.Gadget header><p>{card.gadget}</p></PS.Gadget>}
          <PS.ImageWrapper>
            <PS.Image draggable='false' src={card.thumbnail} onMouseDown={handleMouseDown} />
          </PS.ImageWrapper>
          <S.AddressContainer type={type} hasFrom={card.hasFrom}>
            <PS.TextTitle  >{titleLimiter(card.title)}</PS.TextTitle>

            <PS.AddressText>{titleLimiter(`${card.address.region} - ${card.address.city}, ${card.address.city === 'Curitiba' && 'PR'}`)}
            </PS.AddressText>
            {referencePoint !== 'undefined undefined' && <PS.AddressText>{referencePoint} </PS.AddressText>}
            {card.location !== null && <PS.AddressText>{titleLimiter(card.location ? card.location : '')}</PS.AddressText>}
          </S.AddressContainer>
          <S.ValueContainer>{card.hasFrom && <PS.TextFrom>A partir de:</PS.TextFrom>}
            <PS.TextOthers><PS.TextPrice>{`R$ ${card.uniqueValue?.toFixed(0)},00 `}</PS.TextPrice>noite</PS.TextOthers>
            {card.description !== null && <PS.TextOthers>{card.description}</PS.TextOthers>}

          </S.ValueContainer>

        </PS.Container>
      </PS.GlobalContainer>
    </>
  );
};